// Question Type
export const QUESTION_TYPE = {
  SIMPLE: 'simple',
  DETAIL: 'detail',
};

//AI STATUS
export const AI_STATUS = {
  INIT: 'init',
  READY: 'ready',
};
